// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".snippet_actions-module__container--1jMDs{border-top:1px solid #c6ced5;border-bottom:1px solid #c6ced5;padding:16px}.snippet_actions-module__button--3GkJe{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;padding:0;margin:auto}.snippet_actions-module__label--1012h{font-weight:500;font-size:14px;line-height:21px;letter-spacing:0;color:#36b;margin-right:16px}\n", ""]);
// Exports
exports.locals = {
	"container": "snippet_actions-module__container--1jMDs",
	"button": "snippet_actions-module__button--3GkJe",
	"label": "snippet_actions-module__label--1012h"
};
module.exports = exports;
